import React from 'react';

function ReviewSuccess() {
    return (
        <React.Fragment>
            <h1 className="ckp-ts-h1 u-text-center u-margin-bottom-3">Review Done</h1>
            <header className="ckp-contracts-review-header">
                <div className="ckp-contracts-review-header-text">
                    The contract has been <span className="u-bold">successfully signed</span>.
                    <br />
                    An e-mail with the signed contract was sent to your Clear'em's account inbox.
                </div>
            </header>
            <div className="ckp-contracts-review__success u-text-center">
                <p>
                    <span className="u-bold u-margin-bottom-2">All done here!</span>
                </p>
                <p>
                    An overview of all your contracts, is accessible{' '}
                    <a className="u-bold" href="/contracts">
                        here
                    </a>
                    .
                </p>
            </div>
        </React.Fragment>
    );
}

export default ReviewSuccess;
